import React, { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, endpoints } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export const ContactForm = () => {
  const [form, setForm] = useState({ full_name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post(endpoints.contact, form);
      setDone(true);
      toast.success("Message sent. We’ll reply within 2 business days.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Please try again.");
    } finally { setLoading(false); }
  };

  if (done) return (
    <div data-testid="contact-form-success" className="rounded-xl border border-[hsl(var(--green)/0.25)] bg-[hsl(var(--surface-tint-green))] p-6"><CheckCircle2 className="h-8 w-8 text-[hsl(var(--green))]" /><h3 className="heading-3 mt-2">Message received</h3><p className="lead mt-1">Thank you. Our team will reply within 2 business days.</p></div>
  );

  return (
    <form onSubmit={onSubmit} className="grid gap-4 md:grid-cols-2" data-testid="contact-form">
      <Field label="Full name*"><Input required data-testid="contact-form-full_name" value={form.full_name} onChange={set("full_name")} /></Field>
      <Field label="Email*"><Input required type="email" data-testid="contact-form-email" value={form.email} onChange={set("email")} /></Field>
      <Field label="Phone"><Input data-testid="contact-form-phone" value={form.phone} onChange={set("phone")} /></Field>
      <Field label="Subject*"><Input required data-testid="contact-form-subject" value={form.subject} onChange={set("subject")} /></Field>
      <div className="md:col-span-2"><Field label="Message*"><Textarea required rows={5} data-testid="contact-form-message" value={form.message} onChange={set("message")} /></Field></div>
      <div className="md:col-span-2 flex justify-end"><Button disabled={loading} type="submit" data-testid="contact-form-submit" className="bg-[hsl(var(--navy))] hover:bg-[hsl(var(--navy-2))] text-background">{loading ? "Sending..." : "Send message"}</Button></div>
    </form>
  );
};

const Field = ({ label, children }) => (
  <div><Label className="text-sm font-medium text-[hsl(var(--navy))]">{label}</Label><div className="mt-1.5">{children}</div></div>
);
